import React from "react";
import { useTranslation } from "react-i18next";
import {HomeHeader} from '../components/Header'
import Footer from '../components/Footer'
import HomeSearchBar from '../components/SearchBar'

export default function Home() {
    const { t } = useTranslation();

    React.useEffect(() => {
        document.title = t('home.title')
        const tag = document.createElement('meta');
        tag.setAttribute('name', 'description');
        tag.setAttribute('content', t('home.desc'));
        document.head.appendChild(tag)
    }, []);

    return <div className="l-search-home">
        <HomeHeader />
        <div className="flex-expand"></div>
        <HomeSearchBar />
        <div className="flex-expand"></div>
        <div className="flex-expand"></div>
        <Footer />
    </div>;
}


